import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-footer-address-info',
    templateUrl: './footer-address-info.component.html',
    styleUrl: './footer-address-info.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FooterAddressInfoComponent implements OnInit {

  public componentData: CmsParagraphComponent;

  constructor(public component: CmsComponentData<CmsParagraphComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
